<div class="wrapper__headerComponent container my-5">
  <div class="container mt-5">
    <div class="container mt-4">
      <!-- Título principal -->
      <div class="text-center mb-4">
        <h3>{{ 'cargue-manual.titulo' | translate }}</h3>
        <h5>{{ 'cargue-manual.subtitulo' | translate }}</h5>
      </div>
      <!-- Selección de entidad -->
      <div class="mb-3 row" *ngIf="esSuperAdmin">
        <label for="selectEntidad" class="col-sm-4 col-form-label">
          {{ 'cargue-manual.seleccione' | translate }}
        </label>
        <div class="col-sm-8">
          <select
            id="selectEntidad"
            class="form-select"
            [(ngModel)]="selectedEntity"
            (change)="onEntityChange($event)"
            name="entity">
            <option value="0" disabled selected>Seleccione una entidad</option>
            <option *ngFor="let entity of entity_list" [value]="entity.Id">
              {{ entity.Entidad }}
            </option>
          </select>
        </div>
      </div>
      <!-- Tabla de histórico -->
      <div class="table-container" *ngIf="historial.length > 0; else noData">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'cargue-manual.fecha-corte' | translate }}</th>
              <th>{{ 'cargue-manual.fecha' | translate }}</th>
              <th>{{ 'cargue-manual.usuario' | translate }}</th>
              <th>{{ 'cargue-manual.archivo' | translate }}</th>
              <th>{{ 'cargue-manual.estado' | translate }}</th>
              <th>{{ 'cargue-manual.expedientes' | translate }}</th>
              <th>{{ 'cargue-manual.log' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let hist of historial" id="{{ hist.Id }}">
              <td>{{ hist.Corte | date:'dd-MM-yyyy' }}</td>
              <td>{{ hist.Fecha }}</td>
              <td>{{ hist.Usuario }}</td>
              <td>
                <button
                  class="btn btn-link p-0"
                  (click)="downloadFile(hist.Link)"
                  aria-label="Descargar archivo">
                  {{ hist.Archivo }}
                </button>
              </td>
              <td>{{ hist.Estado }}</td>
              <td>{{ hist.Expedientes }}</td>
              <td>
                <button class="btn btn-link p-0" (click)="download(hist.Hash)"
                  aria-label="Descargar log">
                  Log
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Plantilla para mostrar mensaje si no hay datos -->
      <ng-template #noData>
        <div class="no-data-container">
          <p>{{ mensaje }}</p>
        </div>
      </ng-template>
      <!-- Documentos disponibles -->
      <div class="documents-container">
        <h5>{{ 'cargue-manual.documentos' | translate }}</h5>
        <div class="row" *ngIf="documents.length > 0; else noData2">
          <div class="col-12 col-sm-6 col-md-4 mb-2" *ngFor="let doc of documents">
            <button
              class="btn btn-link w-100 text-start"
              (click)="downloadFile(doc.Link)"
              aria-label="Descargar documento">
              {{ doc.Nombre }}
            </button>
          </div>
        </div>
      </div>
      <!-- Plantilla para mostrar mensaje si no hay datos -->
      <ng-template #noData2>
        <div class="no-data-container">
          <p>{{ mensaje }}</p>
        </div>
      </ng-template>
      <!-- Carga de nuevo archivo -->
      <div
        class="upload-container"
        [class.dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <h5>{{ 'cargue-manual.cargar' | translate }}</h5>
        <div class="upload-box">
          <label for="fileUpload">
            <span class="upload-icon">⬆</span>
            <br />
            {{ 'cargue-manual.arrastre' | translate }}
          </label>
          <input
            id="fileUpload"
            type="file"
            class="file-input"
            accept=".zip"
            (change)="onFileSelected($event)" />
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-fecha-corte
  #modalFechaCorte
  (fechaSeleccionada)="onFechaSeleccionada($event)">
</app-modal-fecha-corte>
